<template>
  <button
    class="btn"
    :class="btnClass"
    v-bind="$attrs"
    v-on="$listeners"
  >
    <template v-if="$attrs.loading">
      <van-loading size="20px" /> {{loadingText}}
    </template>
    <slot v-else></slot>
  </button>
</template>

<script>
export default {
  name: "loading-btn",
  props: {
    btnClass: {
      type: String,
      default: '',
    },
    loadingText: {
      type: String,
      default: '加载中...',
    }
  },
  data () {
    return {
    }
  },
};
</script>

<style lang="less" scoped>
  .btn {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    .van-loading {
      margin-right: 8px;
    }
  }
</style>

